// The heading is intentionally generic: it reads the same whether the
// recommended or modified portfolio carries more, less, or the same risk as the
// current allocation. Risk-comparison wording confused users and did not always
// match the graphic below. This heading has no bold text, so it is a plain
// string.

export const HEADING_MESSAGE =
  'Your investments are arranged to get better use from your risk level.'
